import * as React from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import NavItemStateIndicator, { hoverIndicatorStyles } from "components/common/NavItemStateIndicator";
const StyledButton = styled(Button)(
  ({ theme }) => css`
    padding: 0 15px;
    background: none;
    border: 0;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    && {
      overflow: visible;
    }

    .mantine-Button-label {
      overflow: visible;
    }

    &:hover,
    &:focus-visible {
      ${hoverIndicatorStyles(theme)}
      background: transparent;
      color: ${theme.colors.variant.darker.default};
    }
  `
);
const NavigationButton = ({ children = void 0, ...props }) => /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", type: "button", ...props }, /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, children));
export default NavigationButton;
